/**
 * HUD — minimal status overlay until the full UI lands in Step 5.
 * Bottom-left: render backend + AO state + storage mode. Bottom-right: hints.
 */

export interface HudInfo {
  backend: 'webgpu' | 'webgl2';
  aoEnabled: boolean;
  persistedStorage: boolean;
}

export function mountHud(host: HTMLElement, info: HudInfo): void {
  const style = document.createElement('style');
  style.textContent = `
    .hud {
      position: absolute; bottom: 10px; z-index: 10;
      padding: 4px 10px; border-radius: 6px;
      background: rgba(20, 23, 28, 0.72);
      -webkit-backdrop-filter: blur(6px); backdrop-filter: blur(6px);
      color: #9aa3b2; font-size: 11px; letter-spacing: 0.02em;
      pointer-events: none; white-space: nowrap;
    }
    .hud b { color: #d7dae0; font-weight: 600; }
    .hud-left { left: 10px; }
    .hud-right { right: 10px; }
    @media (max-width: 700px) { .hud-right { display: none; } }
  `;
  document.head.appendChild(style);

  const left = document.createElement('div');
  left.className = 'hud hud-left';
  left.innerHTML =
    `<b>NovaCAD</b> · ${info.backend === 'webgpu' ? 'WebGPU' : 'WebGL 2'}` +
    ` · AO ${info.aoEnabled ? 'on' : 'off'}` +
    ` · storage ${info.persistedStorage ? 'persistent' : 'best-effort'}`;

  const right = document.createElement('div');
  right.className = 'hud hud-right';
  right.textContent =
    'drag: select box (→ whole · ← touching) · ⌥drag/middle: orbit · right-drag: pan · P: push/pull · F fit';

  host.append(left, right);
}
